// Google review summary shown on the homepage testimonial section.
//
// EDIT THESE VALUES when the live Google numbers are confirmed.
//
//   rating     — e.g. "5.0"
//   count      — e.g. "42" (leave empty until the real count is confirmed)
//   profileUrl — link to the Google review profile ("Read All Google Reviews")

export const googleReviewSummary = {
  rating: "",
  count: "",
  profileUrl: "https://g.page/r/CVls-8orlR28EBM",
  writeReviewUrl: "https://g.page/r/CVls-8orlR28EBM/review",
};

export const googleRatingText = () => {
  return googleReviewSummary.rating && googleReviewSummary.count
    ? `${googleReviewSummary.rating} Google Rating • ${googleReviewSummary.count} Google Reviews`
    : "Read Our Google Reviews";
};
